import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { css } from "@emotion/react";
import {
  fontSize,
  fontWeight,
} from "main/javascripts/styles/base/typographyStyle";
import {
  accentColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";

interface IProps extends React.AllHTMLAttributes<HTMLInputElement> {
  min: number;
  max: number;
  name: string;
  onUpdate?: any;
  styles?: any;
}

export const NumberInputSpinner: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const { min, max, name, onUpdate, styles = {} } = props;
  const { exBlockStyle } = styles;

  const { control, setValue } = useFormContext();

  const value = useWatch({
    control,
    name: name,
  });

  const onDecreaseClick = (e): void => {
    e.preventDefault();
    if (value > min) {
      const newNumber = value - 1;
      setValue(name, newNumber);
      if (onUpdate) {
        onUpdate(name, newNumber);
      }
    }
  };
  const onIncreaseClick = (e): void => {
    e.preventDefault();
    if (value < max) {
      const newNumber = value + 1;
      setValue(name, newNumber);
      if (onUpdate) {
        onUpdate(name, newNumber);
      }
    }
  };
  const decreaseButtonStyle =
    value <= min ? [buttonStyle, disabledStyle] : buttonStyle;
  const increaseButtonStyle =
    value >= max ? [buttonStyle, disabledStyle] : buttonStyle;
  return (
    <div css={[blockStyle, exBlockStyle]}>
      <button onClick={onDecreaseClick} css={decreaseButtonStyle}>
        <div css={decreaseStyle} />
      </button>
      <div css={numberStyle}>{value}</div>
      <button onClick={onIncreaseClick} css={increaseButtonStyle}>
        <div css={increaseStyle} />
      </button>
    </div>
  );
};

const blockStyle = css`
  display: flex;
  align-items: center;
`;
const buttonStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border: 0.125rem solid ${accentColor.primaryColor};
  border-radius: 50%;
  padding: 0;
  cursor: pointer;
  outline: none;
  background: #fff;
`;
const decreaseStyle = css`
  position: relative;
  width: 100%;
  height: 100%;
  &:before {
    content: "";
    display: block;
    width: 60%;
    height: 0.125rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${accentColor.primaryColor};
  }
`;
const increaseStyle = css`
  position: relative;
  width: 100%;
  height: 100%;
  &:before {
    content: "";
    display: block;
    width: 60%;
    height: 0.125rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${accentColor.primaryColor};
  }
  &:after {
    content: "";
    display: block;
    width: 0.125rem;
    height: 60%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${accentColor.primaryColor};
  }
`;
const disabledStyle = css`
  opacity: 0.4;
  cursor: default;
`;
const numberStyle = css`
  font-size: ${fontSize.body};
  text-align: center;
  padding: 0 ${space.atom2x};
  color: ${textColor.primaryDarkColor};
  font-weight: ${fontWeight.bold};
  width: 3rem;
`;
